import { EditedClusteringType } from "./types";

export const dataFieldName = "data";

export const formInitState: EditedClusteringType = {
  name: "",
  authGroups: [],
  enabled: true,
  data: {
    comment: "",
    game_group: [],
    game_type: [],
    limit: [],
    pattern: [], //clustering_pattern
    ante: [],
    post_flop: [],
    pre_flop: [],
  }
};